import React from 'react';
import { useTranslation } from 'react-i18next';
import PublicWrapper from 'shared/components/layout/PublicWrapper';

const Support = () => {
  const { t } = useTranslation();
  return (
    <PublicWrapper>
      <div className='border-bottom flex-fill contact-page mt-md-8'>
        <div className='container'>
          <div className='d-flex flex-wrap'>
            <div className='col-md col-12 py-10 py-md-15 pb-20 pr-0 pr-md-16 pl-0'>
              <h2 className='mb-10'>{t('support_title')}</h2>
            </div>
          </div>
        </div>
      </div>
    </PublicWrapper>
  );
};

export default Support;
